






















































































































































































import { mapGetters } from 'vuex'
import sectionIndex from '~/components/section/index/section.vue'
import TransitionExpand from '~/components/transition/transition-expand.vue'

export default {
  name: 'SeoSailingHolidays',
  components: {
    sectionIndex,
    TransitionExpand
  },
  props: {
    withTitle: {
      type: Boolean,
      default: true
    },
    withSubTitle: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      hover: {
        flotilla: false,
        bareboat: false,
        skippered: false,
        'digital-flotilla': false,
        'review.0': false,
        'review.1': false,
        'review.2': false
      }
    }
  },
  computed: {
    ...mapGetters({
      locale: 'lang/locale'
    }),
    getSliderSettings: app => (name) => {
      const isSlider = true
      const SETTINGS = {
        'sailing-holidays': {
          settings: {
            slidesToShow: 1,
            arrows: false,
            responsive: [
              {
                breakpoint: 576,
                settings: {
                  slidesToShow: 1,
                  dots: true,
                  arrows: false
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  dots: true,
                  arrows: false
                }
              },
              {
                breakpoint: 1023,
                settings: {
                  slidesToShow: 3,
                  dots: false,
                  arrows: true
                }
              }
            ]
          }
        }
      }
      return {
        body: {
          isSlider,
          settings: {
            type: 'slider',
            gaps: {
              value: 24
            }
          },
          ...SETTINGS[name]
        }
      }
    }
  },
  methods: {
    changeToggle (name, value = true, params = { type: 'touch' }) {
      if (params.type === 'mouse' && this.$store.state.breakpoint.screen.widthMinCalc <= 1200) {
        return
      }
      this.hover[name] = value
    }
  }
}
